import * as types from './constants';

// Update Avatar
export const updateAvatarRequest = data => (
  { type: types.UPDATE_AVATAR_REQUEST, payload: data }
);

export const updateAvatarDone = data => (
  { type: types.UPDATE_AVATAR_DONE, payload: data }
);

export const updateAvatarFailed = errors => (
  { type: types.UPDATE_AVATAR_FAILED, payload: errors }
);

export const updateAvatarReset = () => (
  { type: types.UPDATE_AVATAR_RESET }
);

// Remove Avatar
export const removeAvatarRequest = data => (
  { type: types.REMOVE_AVATAR_REQUEST, payload: data }
);

export const removeAvatarDone = data => (
  { type: types.REMOVE_AVATAR_DONE, payload: data }
);

export const removeAvatarFailed = errors => (
  { type: types.REMOVE_AVATAR_FAILED, payload: errors }
);